






import {Vue, Component} from 'vue-property-decorator';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';

@Component({
    components: {
        PageWithSidebar,
    },
})
export default class GiftCards extends Vue {
    /* tslint:disable */
    public mounted() {
        (function(g, i, f, t, u, p) {
            i = g.createElement('script');
            f = g.getElementsByTagName('script')[0];
            i.async = 1;
            i.src = 'https://cdn.giftup.app/dist/gift-up.js';
            f.parentNode.insertBefore(i, f);
        })(document);
    }
    /* tslint:enable */
}
